import {
    createSlice,
    PayloadAction,
    createAction,
} from "@reduxjs/toolkit";
import { ProtectorDto } from "../../model/calculations/protector";

interface State {
    loading: boolean;
    error: string | null;
    ProtectorListSeries: any;
    protectorSeries: string;
    ProtectorList: any;
    oilType: string;
    OilContractionList: any;
    protectorCalculationComplete: boolean;
    protectorCalculations: any;
    bearingTypeList: any;
    shaftTypeList: any;
    thrustPercentage: number;
    selectedLowerProtector: ProtectorDto;
    selectedUpperProtector: ProtectorDto;
    shaftRatingValue: number;
    lowerEquipmentList: any;
    upperEquipmentList: any;
    selectedLowerEquipment: any;
    selectedUpperEquipment: any;
    shaftPercentate: number;
}

export const initialState: State = {
    loading: false,
    error: null,
    ProtectorListSeries: null,
    protectorSeries: "0",
    ProtectorList: [],
    oilType: "",
    OilContractionList: [],
    protectorCalculationComplete: false,
    protectorCalculations: [],
    bearingTypeList: [],
    shaftTypeList: [],
    thrustPercentage: 0,
    selectedLowerProtector: {
        housingDiaIn: 0,
        housingDiamm: 0,
        hp: 0,
        hsShaftHP: 0,
        model: "",
        name: "",
        protectorID: "",
        series: "",
        stdShaftHP: 0,
        tempetaureRating: 0,
    },
    selectedUpperProtector: {
        housingDiaIn: 0,
        housingDiamm: 0,
        hp: 0,
        hsShaftHP: 0,
        model: "",
        name: "",
        protectorID: "",
        series: "",
        stdShaftHP: 0,
        tempetaureRating: 0,
    },
    shaftRatingValue: 0,
    lowerEquipmentList: [],
    upperEquipmentList: [],
    selectedLowerEquipment: [{}],
    selectedUpperEquipment: [{}],
    shaftPercentate: 0,
};

export const fetchOilContraction = createAction("protector/loadOilContraction");
export const fetchProtectorCalculations = createAction("protector/loadProtectorCalculations");
export const fetchProtectorPercentage = createAction("protector/loadProtectorPercentage");
export const fetchSelectedProtector = createAction("protector/fetchSelectedProtector");
export const fetchEquipments = createAction("protector/loadEquipments");
export const fetchSelectedLowerProtector = createAction("protector/fetchSelectedLowerProtector");
export const fetchSelectedUpperProtector = createAction("protector/fetchSelectedUpperProtector");


const protectorSlice = createSlice({
    name: "protector",
    initialState,
    reducers: {
        resetProtectorOutput: () => initialState,
        setProtectorListSeries: (state, action: PayloadAction<any>) => {
            state.ProtectorListSeries = action.payload
        },
        setProtectorSeries: (state, action) => {
            state.protectorSeries = action.payload;
        },
        setProtectorList: (state, action: PayloadAction<any>) => {
            state.ProtectorList = action.payload
        },
        setOilContractionList: (state, action: PayloadAction<any>) => {
            state.OilContractionList = action.payload
        },
        setProtectorCalculationComplete(state, action) {
            state.protectorCalculationComplete = action.payload;
        },
        setProtectorCalculations(state, action) {
            state.protectorCalculations = action.payload;
        },
        setBearingType: (state, action) => {
            state.bearingTypeList = action.payload;
        },
        setshaftType: (state, action) => {
            state.shaftTypeList = action.payload;
        },
        setOilType: (state, action) => {
            state.oilType = action.payload;
        },
        setThrustPercentage: (state, action) => {
            state.thrustPercentage = action.payload;
        },
        setShaftPercentage: (state, action) => {
            state.shaftPercentate = action.payload;
        },
        setSelectedLowerProtector: (state, action) => {
            state.selectedLowerProtector = action.payload;
        },
        setSelectedUpperProtector: (state, action) => {
            state.selectedUpperProtector = action.payload;
        },
        setShaftRatingValue: (state, action) => {
            state.shaftRatingValue = action.payload
        },
        setLowerEqupimentList: (state, action) => {
            state.lowerEquipmentList = action.payload
        },
        setUpperEqupimentList: (state, action) => {
            state.upperEquipmentList = action.payload
        },
        setSelectedLowerEquipment: (state, action) => {
            state.selectedLowerEquipment = action.payload
        },
        setSelectedUpperEquipment: (state, action) => {
            state.selectedUpperEquipment = action.payload
        },
    },
})

export const {
    resetProtectorOutput,
    setProtectorListSeries,
    setProtectorSeries,
    setProtectorList,
    setOilContractionList,
    setProtectorCalculationComplete,
    setProtectorCalculations,
    setBearingType,
    setshaftType,
    setOilType,
    setThrustPercentage,
    setSelectedLowerProtector,
    setSelectedUpperProtector,
    setShaftRatingValue,
    setLowerEqupimentList,
    setUpperEqupimentList,
    setSelectedLowerEquipment,
    setSelectedUpperEquipment,
    setShaftPercentage
} = protectorSlice.actions;

export default protectorSlice.reducer